export * from './week.pipe';
export * from './month-year.pipe'
export * from './array-sort.pipe';
export * from './tag-filter.pipe';
export * from './tag-filter-any.pipe';
export * from './file-extension-filter.pipe';
export * from './safe-url.pipe'


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/pipes/index.ts